import { render } from "./PlanilhasController.vue?vue&type=template&id=dd0efd8e&scoped=true"
import script from "./PlanilhasController.vue?vue&type=script&lang=js"
export * from "./PlanilhasController.vue?vue&type=script&lang=js"

import "./PlanilhasController.vue?vue&type=style&index=0&id=dd0efd8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0efd8e"]])

export default __exports__